import * as React from 'react';

import * as styles from './CellGroup.css';

export const CellGroup: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <ul className={styles['container']}>{children}</ul>;
};
